export const MAX_ZOOM = 10;

export const ZOOM_TYPE = {
  zoomIn: 'zoom in',
  zoomOut: 'zoom out',
};

export const HOT_KEYS = {
  arrowUp: 38,
  arrowDown: 40,
};
export const MIN_CHART_HEIGHT = 182;

export const X_AXIS_RIGHT_GAP = 46;

export const LINE_COLORS = [
  '#63EFFF',
  '#75DB29',
  '#A153EC',
  '#FFF350',
  '#FF8C20',
  '#585EF6',
  '#6CDBB5',
  '#F33FA9',
  '#64B5FF',
  '#FF8260',
  '#5823E1',
  '#F1206A',
];
